import React from "react";
import { alertError } from "../../_utils/alerts";
import { findAllRolPagedEvent } from "../../_events/roles/find.event";

export const useAllRolesPaged = ({ page = 0, limit = 8 }) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l) => {
        findAllRolPagedEvent(p, l)
        .then(json => {
            setData(json.paged);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(page, limit);
    }, [page, limit]);

    return { data, loadData };
}